import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { setDealFilters } from '../../store/investor/action';
import { DealFilters } from '../../store/investor/reducer';
import { Button } from '../_custom';
import MultiSelectSearchDropdown from '../ManageDealDrawer/Components/MultiSelectSearchDropdown/MultiSelectSearchDropdown';
import styles from './DealFilterRenderer.module.scss';

interface DealFilterRendererProps {
    options: { label: string; value: string }[];
    isApplied: boolean;
    config: {
        label: string;
        step: keyof DealFilters;
    };
    tempFilters: DealFilters;
    setTempFilters: (filters: DealFilters) => void;
}

export const DealFilterRenderer = ({ options, isApplied, config, tempFilters, setTempFilters }: DealFilterRendererProps) => {
    const handleFilterChange = (filterType: keyof DealFilters, values: string[]) => {
        let filters = {
            [filterType]: values,
        };
        setTempFilters({ ...tempFilters, [filterType]: values });
    };
    return (
        <div className={styles.DealFilterRenderer}>
            <div className={isApplied ? styles.DflexFiltersDone : styles.DflexFilters} style={{ width: '100%' }}>
                <div className={styles.InputLabel} style={{ width: '100%' }}>
                    {config.label}
                    <Button
                        text={'Clear'}
                        type={'reset'}
                        onClick={(e) => {
                            e.preventDefault();
                            handleFilterChange(config.step, []);
                        }}
                        variant={'white'}
                        style={{
                            visibility: isApplied ? 'visible' : 'hidden',
                            marginTop: 0,
                            border: '1px solid #E7E7E7',
                            color: '#4D4D4D',
                            fontSize: '0.75rem',
                            padding: '0.25rem 0.75rem',
                        }}
                    />
                </div>
                <MultiSelectSearchDropdown
                    options={options || []}
                    selectedItems={tempFilters[config.step] || []}
                    placeholder={'All'}
                    toggleSelection={(selectedOptions) => {
                        const validOptions = selectedOptions.filter((v): v is string => v !== null);
                        if (validOptions.length > 0) {
                            handleFilterChange(config.step, validOptions);
                        } else {
                            handleFilterChange(config.step, []);
                        }
                    }}
                />
            </div>
        </div>
    );
};
